export default __webpack_public_path__ + "static/montserrat-v15-latin-ext_latin-regular-dbd57c048932943ca44137ca0559d449.woff";